import { ReactNode } from 'react'

import { Box } from '@chakra-ui/react'

interface EditDeviceModalSectionIProps {
  children: ReactNode
  mb?: number
}

export const EditDeviceModalSection = ({
  children,
  mb = 0,
}: EditDeviceModalSectionIProps) => {
  return (
    <Box bg='#fff' borderRadius='10px' mb={mb} padding='6'>
      {children}
    </Box>
  )
}
